import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { IFetchStatus } from 'types/rest/IFetchStatus';
import { orderSearchInitialState } from './interfaces';
import { ISearchOrderResultData } from '../../ui-toolkit/orders/searchOrder/types/ISearchOrdersResult';

export const ordersSearchSlice = createSlice({
  name: 'ordersSearch',
  initialState: orderSearchInitialState,
  reducers: {
    setOrdersSearchAction: (state, action: PayloadAction<ISearchOrderResultData>) => {
      state.data = action.payload;
    },
    setOrdersSearchFetchStatusAction: (state, action: PayloadAction<IFetchStatus>) => {
      state.fetchStatus = action.payload;
    },
    setOrdersSearchErrorAction: (state, action: PayloadAction<string | null>) => {
      state.fetchError = action.payload;
    },
  },
});
export const { setOrdersSearchAction, setOrdersSearchFetchStatusAction, setOrdersSearchErrorAction } =
  ordersSearchSlice.actions;
